import { alpha, Card, CardContent, Divider, Typography } from '@mui/material';

/**
 * Sticky live-preview wrapper used in the right column of two-column
 * forms. Renders a soft gradient background tinted with the requested
 * palette color (defaults to `primary`), the standard "Preview" overline
 * and a divider, then whatever the caller wants below.
 *
 * Pass `accent="warning"` for incident-style forms where the previewed
 * entity carries an alert/severity meaning.
 */
const PreviewCard = ({ accent = 'primary', children }) => (
  <Card
    variant="outlined"
    sx={{
      background: (theme) =>
        `linear-gradient(135deg, ${alpha(theme.palette[accent].main, 0.04)} 0%, ${alpha(theme.palette[accent].main, 0.12)} 100%)`,
    }}
  >
    <CardContent>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ fontWeight: 600, letterSpacing: 0.8 }}
      >
        Preview
      </Typography>
      <Divider sx={{ my: 1.5 }} />
      {children}
    </CardContent>
  </Card>
);

export default PreviewCard;
